import React from 'react';
import Box from '@mui/material/Box';
import ListItems from 'components/Common/ListItems';

const DashboardAssets = (props) => {
  const { myProfile } = props;
  const assets = myProfile?.assignedAssets;

  if (!assets || assets.length === 0) {
    return null;
  }

  return (
    <>
      {assets.map((item, index) => {
        const { assetTag, serial, type } = item;
        const title = `${type.val} ( Tag: ${assetTag}, Serial: ${serial} )`;
        return (
          <Box key={index}>
            <ListItems title={title} />
          </Box>
        );
      })}
    </>
  );
};

export default DashboardAssets;
